import {type VariantProps} from 'class-variance-authority';
import {Toggle as TogglePrimitive} from 'radix-ui';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {toggleVariants} from './toggle-variants';

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({className, variant, size, children, ...props}, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({variant, size}), className)}
    {...props}
  >
    {children}
  </TogglePrimitive.Root>
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export {Toggle};
